module.exports = __webpack_public_path__ + "img/i_h_my.3d7376a0.svg";